import intl from 'react-intl-universal';

import { OccType, SourceChannelType } from '@/config/constant';
import DateJS from '@/utils/date';
import { PRICE_REG } from '@/config/reg';
import { ReducerState } from '@/redux/reducers/reservation/createReserve';
import { findItemByKey } from '@/redux/actions/reservation/helper';
import {
  ValidateSchema,
  createValidator,
  channelValidator,
} from '@/pages/reservation/utils/validator';
import { EMAIL_REG } from '@/components/BaseEmailInput';
import { validateMobileValue } from '@/components/BaseMobileInput/helper';

const customerInfo: (value: ReducerState['customerInfo'], data: ReducerState) => void = (
  value,
  data,
) => {
  const { name, mobile, otaOrderNo, email } = value;
  const { appendOrderId } = data.commonInfo;
  let err;
  switch (true) {
    case !name:
      err = 'reservation_error_booker_null';
      break;
    case !(otaOrderNo || mobile || email):
      err = 'reservation_error_booker_contact_null';
      break;
    case email && !EMAIL_REG.test(email):
      err = 'order_frontDesk_validate_please_check_email_error_format';
      break;
    case !appendOrderId && mobile && !validateMobileValue(mobile):
      err = 'order_frontDesk_validate_please_check_mobile_error_format';
      break;
    default:
      err = '';
      break;
  }
  if (err) {
    throw new Error(intl.get(err));
  }
};

const commonInfo: (value: ReducerState['commonInfo'], data: ReducerState) => void = (
  value,
  data,
) => {
  const { dayTypeTimeInfo, hourTypeTimeInfo } = data;
  const { occType, lastAuditDate } = value;
  const rentTimeInfo = occType === OccType.DayUse ? dayTypeTimeInfo : hourTypeTimeInfo;
  const { rentTime, expectedArrivalTime } = rentTimeInfo;
  let err;
  switch (true) {
    case !expectedArrivalTime:
      err = 'reservation_error_eta_null';
      break;
    case !rentTime:
      err = 'reservation_error_duration_null';
      break;
    case lastAuditDate && DateJS(lastAuditDate).isAfter(expectedArrivalTime):
      err = 'reservation_error_eta_invalid';
      break;
    // case DateJS(DateJS()).isAfter(expectedArrivalTime):
    //   err = '预抵时间不能早于当前时间';
    //   break;
    default:
      err = '';
      break;
  }
  if (err) {
    throw new Error(intl.get(err));
  }
};

const rentRoomInfos: (value: ReducerState['rentRoomInfos']) => void = (value) => {
  const rentList = value || [];
  if (!rentList.length) throw new Error(intl.get('reservation_error_room_count_null'));
  rentList.forEach((item) => {
    const { roomPriceList } = item;
    (roomPriceList || []).forEach((rentDay) => {
      if (!rentDay.inputPrice) {
        throw new Error(intl.get('reservation_error_room_price_null'));
      }
      if (!PRICE_REG.test(rentDay.inputPrice)) {
        throw new Error(intl.get('reservation_error_room_price_invalid'));
      }
    });
  });
};

// 校验暂存渠道信息
const checkStashChannelInfo: (value: ReducerState['channelInfo'], data: ReducerState) => void = (
  value,
  data,
) => {
  const { channelList } = data;
  const { channelId, otaPaymentAmount } = value;
  const selectChannel = findItemByKey(channelList, 'id', channelId);
  const isOTAChannel = selectChannel?.type === SourceChannelType.OTA;
  if (isOTAChannel && !PRICE_REG.test(otaPaymentAmount)) {
    throw new Error(intl.get('reservation_error_ota_amount_invalid'));
  }
};

// 校验暂存房间信息
const checkStashRoomInfos: (value: ReducerState['rentRoomInfos']) => void = (value) => {
  const rentList = value || [];
  rentList.forEach((item) => {
    const { roomPriceList } = item;
    (roomPriceList || []).forEach((rentDay) => {
      if (!PRICE_REG.test(rentDay.inputPrice)) {
        throw new Error(intl.get('reservation_error_room_price_invalid'));
      }
    });
  });
};

// 暂存时校验
const stashSchema: ValidateSchema<ReducerState> = {
  channelInfo: checkStashChannelInfo,
  rentRoomInfos: checkStashRoomInfos,
};

export const validateStashData = createValidator<ReducerState>(stashSchema);

const submitSchema: ValidateSchema<ReducerState> = {
  customerInfo,
  channelInfo: channelValidator,
  commonInfo,
  rentRoomInfos,
};

export const validateSubmitData = createValidator<ReducerState>(submitSchema);
